// Fetch list

export const FETCH = 'trailerTypes.FETCH'
export const FETCH_STARTED = 'trailerTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'trailerTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'trailerTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'trailerTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'trailerTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'trailerTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'trailerTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'trailerTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'trailerTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'trailerTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'trailerTypes.SAVE'
export const SAVE_STARTED = 'trailerTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'trailerTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'trailerTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'trailerTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'trailerTypes.DELETE'
export const DELETE_STARTED = 'trailerTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'trailerTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'trailerTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'trailerTypes.DELETE_CANCELLED'

// Export

export const EXPORT = 'trailerTypes.EXPORT'
export const EXPORT_FULFILLED = 'trailerTypes.EXPORT_FULFILLED'
